import { constant } from './ContextualHelpActionsConstant'
let initialState = {
    contextualHelp: []
}


const ContextualHelpReducer = (state = initialState, action) => { 
    switch (action.type) {
        case constant.CONTEXTUAL_HELP_FETCH_IN_PROGRESS:
            return { ...state, getContextualHelpInProgress: true };
        case constant.CONTEXTUAL_HELP_FETCH_COMPLETE:
            return { ...state, getContextualHelpInProgress: false, contextualHelp: action.data };
        default:
            return state;
    }
}

export default ContextualHelpReducer;